module.exports = __webpack_public_path__ + "img/characters.76b836b2.png";